import { useInfiniteQuery } from '@tanstack/react-query'
import {
  getCareReasonsPaginated,
  CARE_REASONS_PAGE_SIZE,
} from '@/services/careReasonsService'
import { useAuth } from '@/hooks/useAuth'
import type { CareReasonsPage } from '@/services/careReasonsService'
import { INFINITE_CARE_REASONS_KEY } from '@/constants/queryKeys'
import type { QueryDocumentSnapshot, DocumentData } from 'firebase/firestore'

export function useInfiniteCareReasons() {
  const { churchId } = useAuth()

  return useInfiniteQuery<
    CareReasonsPage,
    Error,
    {
      pages: CareReasonsPage[]
      pageParams: (QueryDocumentSnapshot<DocumentData> | null)[]
    },
    string[],
    QueryDocumentSnapshot<DocumentData> | null
  >({
    queryKey: [INFINITE_CARE_REASONS_KEY, churchId!],
    queryFn: ({ pageParam }) => getCareReasonsPaginated(churchId!, pageParam),
    initialPageParam: null,
    getNextPageParam: (lastPage) =>
      lastPage.careReasons.length < CARE_REASONS_PAGE_SIZE
        ? undefined
        : lastPage.lastDoc,
    enabled: !!churchId,
  })
}
